import React from "react";
import FixedView from "../../components/FixedView";
import { imageAddress } from "../../utils/useful";
import IconMap from "./IconMap";
import autosize from "autosize";

export default class FileItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            type: this.typeofFile(props.name),
            showContextMenu: false,
            filesPic: ['png', 'jpg', 'jpeg', 'svg','gif'],
            videoExtentions: ['mp4'],

            file: ''
        }
        this.inputFile = React.createRef();
    }
    componentDidMount() {
        let file = this.state.file
        let fileList = String(this.props.item?.address).split('.')
        file = fileList[fileList.length - 1]
        this.setState({ file }, () => {
        })
        // if (this.props.rename) {
        //     document.addEventListener('keypress', this.onKeyPress)
        // }
        // this.editName.focus()
        // autosize(this.editName)
        // document.addEventListener('click', this._handleClick)
    }
    componentWillUnmount() {
        // document.removeEventListener('click', this._handleClick)
    }
    // _handleContextMenu = (event) => {
    //     event.preventDefault();
    //     this.fixedView.showView()
    // }

    componentDidUpdate() {
        if (this.props.rename) {
            document.addEventListener('keypress', this.onKeyPress)
        }
    }

    onKeyPress = (event) => {
        if (event.key === "Enter") {
            document.removeEventListener('keypress', this.onKeyPress);
            const newName = this.inputFile.current.value;
            this.props.onRenameItem(newName)
        }
    }

    typeofFile(fileName) {
        if (fileName) {
            let dotIndex = fileName.lastIndexOf('.');
            if (dotIndex == -1)
                return "unknown"

            return fileName.slice(dotIndex + 1)

        } else {
            return ''
        }

    }

    _handleFileName() {
        return (
            this.props.rename ?
                <input ref={this.inputFile} className="folderNameInput renameInput py-1 br-5" rows={1} id="fileNameInput" autoFocus={true} style={{ zIndex: 3 }} defaultValue={this.props?.name} />
                : (
                    <div className="flexcc w-100 no_selection" style={{ disply: 'flex', justifyContent: 'center' }}>
                        {this.props.view === 'details' &&
                            <p className="font-size-13 px-1 w-100" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingLeft: '5px' }}>{this.props?.name + '.' + this.props.item?.extension}</p>
                        }
                        {this.props.view === 'mediumIcons' &&
                            <p className="font-size-12 px-1 mt-1 w-100 flexcc" style={{ width: '69px', whiteSpace: 'pre-wrap', wordBreak: 'break-all', paddingBottom: '1px', textAlign: 'center' }}>{String(this.props?.name + this.props.item?.extension).length > 19 ? String(this.props?.name + '.' + this.props.item?.extension)?.substr(0, 19) + '...' : this.props?.name + '.' + this.props.item?.extension}</p>
                        }
                    </div>
                )
        )
    }

    // onDoubleClickHandler = () => {
    //     if (this.clickTimeOut !== null) {
    //         clearTimeout(this.clickTimeOut)
    //         this.clickTimeOut = null;
    //         return;
    //     }
    //     this.clickTimeOut = setTimeout(() => {
    //         clearTimeout(this.clickTimeOut)
    //         this.clickTimeOut = null;
    //     }, 200);
    //     this.setState({ rename: true })
    //     // this.onrename()

    // };

    render() {
        if (this.props.view === 'details') {
            return (
                <div ref={el => this.currentNode = el} className='w-100 folderItem'>
                    < div className=" d-flex w-100" style={{ alignItems: 'center' }} >
                        <div className="d-flex prd-2" >
                            {/* {console.log(this.state.file ,this.state.filesPic.includes(this.state.file?.toLowerCase()))} */}
                            {/* <img src={IconMap[this.props.item?.extension?.toLowerCase()] ? IconMap[this.props.item?.extension?.toLowerCase()] : (this.state.filesPic.includes(this.state.file?.toLowerCase()) ? imageAddress(this.props.item?.address) : '/assets/icons/applets/drive/unknown-file.svg')} alt="" draggable={false} style={{}} /> */}
                            {this.state.filesPic.includes(this.state.file?.toLowerCase()) ? (
                                <img src={imageAddress(this.props.item?.address, 'image', 'mini')} alt="" draggable={false} style={{width:25,maxHeight:30,objectFit:'contain'}} />
                            ) : (
                                <>
                                    {/* {console.log(this.props.item)} */}
                                    {(this.state.videoExtentions.includes(this.state.file?.toLowerCase()) && this.props.item?.cover) ? (
                                        <>
                                        <img src={imageAddress(this.props.item?.cover,'videoCover','small')} alt="" draggable={false} style={{width:25,maxHeight:30,objectFit:'contain'}} />
                                        </>
                                    ) : (
                                        <img src={(IconMap[this.props.item?.extension?.toLowerCase()] ?? '/assets/icons/applets/drive/unknown.png')} alt="" draggable={false} style={{width:25,maxHeight:30,objectFit:'contain'}} />

                                    )}
                                </>
                            )}

                        </div>
                        <div className="flexcc" style={{ display: 'flex', justifyContent: 'left', width: 'calc(100% - 41px)' }}>
                            {this._handleFileName()}
                        </div>
                    </div>
                </div>
            )
        }
        else if (this.props.view === 'mediumIcons') {
            return (
                <div ref={el => this.currentNode = el} className='w-100 folderItemGridView mb-4' style={{ height: '80px' }}>

                    <div className=" d-flex " style={{ flexDirection: 'column', alignItems: 'center', borderRadius: '5px' }}>
                        <div className="flexcc" style={{ width: '45px', height: '45px' }}>
                            {/* <img src={IconMap[this.props.item?.extension?.toLowerCase()] ? IconMap[this.props.item?.extension?.toLowerCase()] : (this.state.filesPic.includes(this.state.file?.toLowerCase()) ? imageAddress(this.props.item?.address) : '/assets/icons/applets/drive/unknown-file.svg')} alt="" style={{ height: '40px', marginTop: '5px', }} draggable={false} /> */}
                            {this.state.filesPic.includes(this.state.file?.toLowerCase()) ? (
                                <img src={imageAddress(this.props.item?.address)} alt="" draggable={false} height={40} width={40} style={{ objectFit: 'contain' }} />
                            ) : (
                                <>
                                    {/* {console.log(this.props.item)} */}
                                    {(this.state.videoExtentions.includes(this.state.file?.toLowerCase()) && this.props.item?.cover) ? (
                                        <img src={imageAddress(this.props.item?.cover,'videoCover','small')} alt="" draggable={false} height={40} width={40} style={{ objectFit: 'contain' }} />
                                    ) : (
                                        <img src={(IconMap[this.props.item?.extension?.toLowerCase()] ?? '/assets/icons/applets/drive/unknown.png')} alt="" draggable={false} height={40} width={40} style={{ objectFit: 'contain' }} />

                                    )}
                                </>
                            )}
                        </div>
                        <div className="mt-1" style={{ disply: 'flex', justifyContent: 'center', height: '40px' }}>
                            {this._handleFileName()}
                        </div>
                    </div>
                </div>
            )
        }
    }
}
